import { createAsyncThunk } from '@reduxjs/toolkit';
import { UpdateDocumentMetadataSignalRResponse } from '@v2/components/imageHandling/types/types';
import { AppDispatch } from '@store/types';
import { pushMessage } from '@reducers/v2/messagesBus/messagesBus.slice';
import { ImageDocumentMessageType } from '@reducers/v2/messagesBus/types';

export const updateImageMetadataMessageProducer = createAsyncThunk<void, UpdateDocumentMetadataSignalRResponse, { dispatch: AppDispatch }>(
  'imageHandlingV2/updateImageMetadataMessageProducer',
  async (params, { dispatch }) => {
    //TODO: handle error
    if (!params.isError) {
      dispatch(
        pushMessage({
          key: params.documentId,
          message: {
            messageType: ImageDocumentMessageType.IMAGE_METADATA_UPDATED,
            payload: params,
          },
        })
      );
    }
  }
);
